export default __webpack_public_path__ + "static/media/paypal.d139bbd8.svg";